<template>
	<div class="home">
		<div class="home-top-img">
			<home-swiper @handleTop="handleTop" />
		</div>
		<div class="container">
			<!-- 走马灯下方：一张连续圆环底图，同时铺在核心技术底部 + 行业方案上半 -->
			<div
				class="home-tech-solution"
				v-lazy:background-image="sectionBgImg"
			>
				<core-technology />
				<industry-solutions />
			</div>
			<news-info />
			<open-platform />
		</div>
	</div>
</template>

<script>
import HomeSwiper from './childCpn/HomeSwiper'
import CoreTechnology from './childCpn/CoreTechnology.vue'
import IndustrySolutions from './childCpn/IndustrySolutions'
import NewsInfo from './childCpn/NewsInfo'
import OpenPlatform from './childCpn/OpenPlatform'
export default {
	name: 'Home',
	data() {
		return {
			/* 设计稿：https://js.design/f/eGCLdB?p=nWARn3MmAO&mode=programmer&linkelement=39e1367b-65c5-4b10-b433-f52c821854e9 */
			sectionBgImg: require('@/assets/img/home/home_bg1.png'),
		}
	},
	watch: {},
	created() {},
	methods: {
		handleTop(path) {
			if (path) {
				this.$router.push(path)
			}
		},
	},
	components: {
		HomeSwiper,
		CoreTechnology,
		IndustrySolutions,
		NewsInfo,
		OpenPlatform,
	},
	computed: {},
	mounted() {},
	destroyed() {},
}
</script>
<style lang="scss" scoped>
.home {
	.home-top-img {
		width: 100%;
		/* 1920→1440：高度固定设计稿 850px，宽度变窄时由 cover 裁切 */
		height: 850px;
		margin-top: 64px;
		overflow: hidden;
	}
	.container {
		position: relative;
	}

	/* 核心技术 + 行业解决方案共用一张高图，自顶部向下铺开 */
	.home-tech-solution {
		position: relative;
		background-repeat: no-repeat;
		background-position: center top;
		/* 按宽度等比缩放，保留图高，连续覆盖两模块 */
		background-size: 100% auto;
		overflow: hidden;
	}
}
/* 手机端 375 × 480 */
@media screen and (max-width: 768px) {
	.home {
		.home-top-img {
			width: 100%;
			height: calc(100vw * 480 / 375);
			margin-bottom: 48px;
			margin-top: 44px;
		}

		.home-tech-solution {
			/* 覆盖 v-lazy 内联底图，手机端不展示圆环背景 */
			background-image: none !important;
		}
	}
}
</style>
